export enum RequestStatus {
  Pending = 0,
  InProgress = 1,
  Completed = 2,
  Cancelled = 3,
  OnHold = 4,
  Error = 5,
  Open = 6,
  Sent = 7,
  Received = 8,
  Printed = 9,
  Canceled = 10,
}

export const RequestStatusLabels: Record<RequestStatus, string> = {
  [RequestStatus.Pending]: 'Pending',
  [RequestStatus.InProgress]: 'In Progress',
  [RequestStatus.Completed]: 'Completed',
  [RequestStatus.Cancelled]: 'Cancelled',
  [RequestStatus.OnHold]: 'On Hold',
  [RequestStatus.Error]: 'Error',
  [RequestStatus.Open]: 'Open',
  [RequestStatus.Sent]: 'Sent',
  [RequestStatus.Received]: 'Received',
  [RequestStatus.Printed]: 'Printed',
  [RequestStatus.Canceled]: 'Canceled',
};

export const RequestStatusOptions = Object.entries(RequestStatusLabels).map(
  ([value, label]) => ({
    value: Number(value) as RequestStatus,
    label,
  })
);
